export const GET_LIST_KIEMKHO = "GET_LIST_KIEMKHO";
export const GET_LIST_KIEMKHO_SUCCESS = "GET_LIST_KIEMKHO_SUCCESS";
export const GET_LIST_KIEMKHO_FAILURE = "GET_LIST_KIEMKHO_FAILURE";

export const UPDATE_SEARCHTDATA_KIEMKHO = "UPDATE_SEARCHTDATA_KIEMKHO";
